import { StyleSheet } from "aphrodite";
import theme from "../../../common/theme/mellon";

export default StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        marginBottom: 15,
        "@media (max-width: 799px)": {
            flexDirection: "column",
        },
        width: "100%"
    },
    textValue: {
        overflow: "visible",      
        whiteSpace: "normal",      
        textOverflow: "unset",   
        flexShrink: 0,
        maxWidth: "unset",  
        "@media (max-width: 799px)": {
            width: "auto",
            maxWidth: "unset"     
        },
    },
    rowContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        whiteSpace: "normal",
        color: theme.palette.primary.dark,
        marginRight: 20,
        "@media (max-width: 799px)": {
            marginRight: 0,
        },
    },
    marginEmptyData: {
        marginTop: 15,
    },
})